import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Melrose/Hero";
import IndustriesContent from "../components/Melrose/IndustriesContent";
import PageTitle from "../components/Melrose/PageTitle";

import '../assets/Webdevelopment.css';



const Melrose = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  </div>
	)
}

export default Melrose;
